import { render } from "./ModalCadastrarItemOsTablets.vue?vue&type=template&id=06038448"
import script from "./ModalCadastrarItemOsTablets.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarItemOsTablets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__